import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { usePostSetPasswordMutation } from "../../../services/auth";
import {
  Loader,
  STORAGE_KEYS,
  removeFromStorage,
  showError,
  showToast,
} from "../../../constants";
import { temporaryToken } from "../../../reducers/authSlice";
import { useAppDispatch } from "../../../hooks/store";
import useTranslation from "../../../hooks/Translation";

const ResetPassword = () => {
  const translation = useTranslation() as any;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [resetPassword, { isLoading }] = usePostSetPasswordMutation();

  const [email, setEmail] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleshowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      passwordConfirmation: "",
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .label("Password")
        .required(translation.error.passwordReq)
        .min(6, translation.error.passReq),

      passwordConfirmation: Yup.string()
        .oneOf([Yup.ref("newPassword")], translation.auth.passMatch)
        .required(translation.auth.confirmPasswordReq),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);

      let body = {
        password: formik.values.newPassword,
      };

      try {
        const response = await resetPassword(body).unwrap();
        if (response?.statusCode === 200) {
          showToast(translation.other.passSet || "");
          removeFromStorage(STORAGE_KEYS.tempToken);
          dispatch(
            temporaryToken({
              tempToken: null,
            })
          );
        }
      } catch (error: any) {
        showError(error?.data?.message || "");
      }
      formik.setSubmitting(false);
      navigate("/", {
        replace: true,
      });
    },
  });

  return (
    <div className="authh">
      <Loader isLoad={isLoading} />
      <div className="conta_iner">
        <div className="auth_parnt">
          <div className="auth_left">
            <figure className="authLogo">
              <img src="/static/images/logo.png" alt="" />
            </figure>
            <h2>{translation.auth.resetPass}</h2>
            <Box sx={{ paddingBottom: 5 }}></Box>
            <form onSubmit={formik.handleSubmit}>
              <FormControl sx={{ mb: 2, width: "100%" }}>
                <Typography className="custom_label">
                  {translation.auth.password}
                </Typography>
                <TextField
                  sx={{ m: 0 }}
                  hiddenLabel
                  placeholder={translation.auth.password}
                  fullWidth
                  margin="normal"
                  name="newPassword"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  className="text_field"
                  id="newPassword"
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.newPassword}
                  helperText={
                    formik.touched.newPassword && formik.errors.newPassword
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment className="eye_btn" position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
              <FormControl sx={{ width: "100%" }}>
                <Typography className="custom_label">
                  {translation.auth.confmPas}
                </Typography>
                <TextField
                  sx={{ m: 0 }}
                  hiddenLabel
                  placeholder={translation.auth.confmPas}
                  fullWidth
                  margin="normal"
                  name="passwordConfirmation"
                  type={showConfirmPassword ? "text" : "password"}
                  variant="outlined"
                  className="text_field"
                  id="passwordConfirmation"
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.passwordConfirmation}
                  helperText={
                    formik.touched.passwordConfirmation &&
                    formik.errors.passwordConfirmation
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment className="eye_btn" position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleshowConfirmPassword}
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
              <Box sx={{ pt: 3 }}>
                <Button
                  className="btn btn_primary"
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  // onClick={() => navigate("/")}
                >
                  {translation.globals.submit}
                </Button>
              </Box>
            </form>
          </div>
          <div className="auth_ryt">
            <div className="absolute_div">
              <h3>{translation.auth.welcome}</h3>
              <p>{translation.auth.already}</p>
              <Box sx={{ pt: 3, display: "flex", justifyContent: "center" }}>
                <Button
                  className="btn"
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  onClick={() => navigate("/")}
                >
                  {translation.auth.login}
                </Button>
              </Box>
            </div>
            <figure>
              <img src="/static/images/cook2.jpg" alt="" />
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
